<template>
  <main>
    <div class="columns is-gapless">
      <div class="column">
        <!--<Header></Header>-->

        <div class="header-top" style="background-color: #4d4d4f;">
          <div class="level">
              <div class="level-item has-text-centered">
                <img class="level-item" width="120" :src="logo">
              </div>
          </div>
        </div>

        <section class="section">
          <!--<transition name="fade">-->
            <!--<Danger v-show="dangerVisible"></Danger>-->
          <!--</transition>-->
          <h1 class="not-found">Request Deleted</h1>
          <p>Sorry, the Quote Request you're trying to view is deleted.</p>
          <p>Please contact the builder.</p><br>
          <div class="info-panel">
            <p>Buildxact offers state of the art job management software for the professionals in the trades industry.<br>Sign up for your 14 day free trial online.<br><br></p>
          <a href="https://www.buildxact.com" title="Open Buildxact in a new window or tab" target="_blank" class="button is-warning">Go to Buildxact &gt;</a>
          </div>
        </section>
        <Footer :hide-logo="false"></Footer>
      </div>
    </div>
  </main>

</template>

<script>

// import Header from '@/components/Header'
import Footer from '@/components/Footer.vue'
import logo from '@/assets/logo_150px_white.png'

// import Danger from '@/components/alerts/Danger'

export default {
  name: 'deleted',
  props: [],
  mounted () {
  },
  beforeCreate () {
    // What do we want to do with this page!
    // window.location.href = 'https://www.buildxact.com.au/'
  },
  data () {
    return {
      logo
    }
  },
  methods: {

  },
  components: {
    // Header,
    Footer
    // Danger
  },
  computed: {
    dangerVisible () {
      return this.$store.state.dangerVisible
    }
  }
}
</script>
